import { useEffect } from "react"

const useConfirmBeforeLeaving = (shouldConfirm: boolean): void => {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!shouldConfirm || window.disableConfirmBeforeLeaving) {
        return
      }

      // Standard for most browsers
      e.preventDefault()
    }

    window.addEventListener("beforeunload", handleBeforeUnload)

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [shouldConfirm])
}

export { useConfirmBeforeLeaving }
